import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchUsers_idAccess = z.any()
export type TagsPatchUsers_idAccess = z.infer<typeof tagsPatchUsers_idAccess>

export const descriptionPatchUsers_idAccess = z.any()
export type DescriptionPatchUsers_idAccess = z.infer<typeof descriptionPatchUsers_idAccess>

export const paramsPatchUsers_idAccess = z.object({ "id": z.string().uuid() })
export type ParamsPatchUsers_idAccess = z.infer<typeof paramsPatchUsers_idAccess>

export const bodyPatchUsers_idAccess = z.object({ "role": z.union([z.literal("READ_ONLY"), z.literal("INVOICE_EDITOR"), z.literal("POWER_USER")]), "allBuildingsAccess": z.boolean(), "buildingIds": z.array(z.string().uuid()) })
export type BodyPatchUsers_idAccess = z.infer<typeof bodyPatchUsers_idAccess>

export const responsePatchUsers_idAccess = z.any()
export type ResponsePatchUsers_idAccess = z.infer<typeof responsePatchUsers_idAccess>

interface IPatchUsers_idAccess extends BaseMethodType {
  tags: TagsPatchUsers_idAccess,
  description: DescriptionPatchUsers_idAccess,
  params: ParamsPatchUsers_idAccess,
  body: BodyPatchUsers_idAccess,
  response: ResponsePatchUsers_idAccess
}
export const URL = '/users/:id/access'
export const validation = {
  patch: {
    tags: tagsPatchUsers_idAccess,
    description: descriptionPatchUsers_idAccess,
    params: paramsPatchUsers_idAccess,
    body: bodyPatchUsers_idAccess,
    response: responsePatchUsers_idAccess
  }
}
export interface Users_idAccess extends BaseRouteType {
  patch: IPatchUsers_idAccess
}